import { findRef } from "./findRef.js";
const findMasterRef = refs => {
  return findRef(refs, ref => ref.isMasterRef);
};
export { findMasterRef };
